var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrainingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7458_22784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9999 10.4359L65.8325 4.52858C66.4532 4.39322 67.0962 4.39651 67.7154 4.53821C68.3346 4.67991 68.9146 4.95649 69.4138 5.34809C69.9129 5.73968 70.3187 6.23655 70.602 6.80298C70.8854 7.36942 71.0392 7.99135 71.0525 8.62407V59.176C71.042 60.1536 70.6902 61.097 70.0575 61.8443C69.4248 62.5916 68.5507 63.0962 67.5852 63.2715L35.9999 69.5563L4.41463 63.2998C3.44435 63.1236 2.56652 62.6149 1.93325 61.8617C1.29998 61.1086 0.951173 60.1585 0.947266 59.176V8.62407C0.960553 7.99135 1.1144 7.36942 1.39775 6.80298C1.68111 6.23655 2.08692 5.73968 2.58603 5.34809C3.08515 4.95649 3.66515 4.67991 4.28437 4.53821C4.90358 4.39651 5.54662 4.39322 6.16727 4.52858L35.9999 10.4359Z",
    stroke: "url(#paint0_linear_7458_22784)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.227 56.4582C45.5822 56.4582 53.166 48.9041 53.166 39.5856C53.166 30.267 45.5822 22.7129 36.227 22.7129C26.8719 22.7129 19.2881 30.267 19.2881 39.5856C19.2881 48.9041 26.8719 56.4582 36.227 56.4582Z",
    stroke: "url(#paint1_linear_7458_22784)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9922 46.6158V32.5647L44.6964 39.5855L31.9922 46.6158Z",
    stroke: "url(#paint2_linear_7458_22784)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9995 11.0493L35.8574 22.7224",
    stroke: "url(#paint3_linear_7458_22784)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9995 57.2888L35.8574 68.9619",
    stroke: "url(#paint4_linear_7458_22784)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7458_22784",
    x1: 11.0238,
    y1: 7.22733,
    x2: 48.6055,
    y2: 53.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7458_22784",
    x1: 24.1575,
    y1: 24.1626,
    x2: 43.859,
    y2: 46.6917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7458_22784",
    x1: 33.8182,
    y1: 33.1683,
    x2: 42.092,
    y2: 41.6891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7458_22784",
    x1: 35.8778,
    y1: 11.5508,
    x2: 36.0685,
    y2: 11.5534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7458_22784",
    x1: 35.8778,
    y1: 57.7903,
    x2: 36.0685,
    y2: 57.7929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7458_22784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingIcon);
export default __webpack_public_path__ + "static/media/training-icon.dc68616a.svg";
export { ForwardRef as ReactComponent };